import { ServiceRowSkeleton } from "@App/Components/common/ServiceRow/ServiceRowSkeleton";
import type { FunctionComponent, MouseEventHandler, ReactNode } from "react";

export type ServiceRowProps = {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  loading?: boolean;
  onClick: MouseEventHandler<HTMLDivElement>;
};

export const ServiceRow: FunctionComponent<ServiceRowProps> = ({
  icon,
  title,
  subtitle,
  loading = false,
  onClick,
}: ServiceRowProps) => {
  if (loading) {
    return <ServiceRowSkeleton />;
  }

  return (
    <div
      data-testid="service-row"
      className="flex items-center gap-3 w-full max-w-[300px] md:w-[300px] border-[0.5px] border-neutral-300 rounded py-2.5 px-3 cursor-pointer hover:border-primary"
      onClick={onClick}
    >
      {/* Icons are normalized on height only — they have differing aspect ratios and a 1px stroke,
          so forcing both axes letterboxes them and thins the stroke to sub-pixel. 52px fits the
          widest current icon (Glas, ratio 1.76) at h-7; an icon wider than ratio 1.86 would overflow. */}
      <div className="w-[52px] shrink-0 flex justify-center [&>svg]:h-7 [&>svg]:w-auto">{icon}</div>
      <div data-testid="service-row-text" className="min-w-0">
        <div
          className="font-serif text-sm hyphens-auto"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {subtitle && (
          <div className="text-[0.6875rem] text-neutral-600 mt-0.5 hyphens-auto break-words">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};
